type Nullable<T = void> = T | null | undefined;

/** @see https://developer.mozilla.org/en-US/docs/Glossary/Nullish */
export function isNullish<T>(value: Nullable<T>): value is null | undefined {
  return value === null || value === undefined;
}

/* Returns False if the argument is either null or undefined. */
export function isDefined<T>(value: Nullable<T>): value is T {
  return !isNullish(value);
}

// Converts nullish values (null or undefined) to null, leaves others unchanged
export function nullishToNull<T>(value: T | null | undefined): T | null {
  return value ?? null;
}

// Converts nullish values (null or undefined) to undefined, leaves others unchanged
export function nullishToUndefined<T>(value: T | null | undefined): T | undefined {
  return value ?? undefined;
}
